import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * Suppresses the host's matTooltip unless its text is actually truncated,
 * so a tooltip only appears when the ellipsis is hiding something.
 *
 * The overflow check runs on mouseenter rather than as a binding to avoid
 * forcing a layout read on every cell of every change detection cycle.
 */
@Directive({
    selector: '[appTooltipIfTruncated]',
    standalone: true
})
export class TooltipIfTruncatedDirective {

  constructor(
    private el: ElementRef<HTMLElement>,
    private tooltip: MatTooltip
  ) { }

  @HostListener('mouseenter') onMouseEnter() {
    const element = this.el.nativeElement;
    this.tooltip.disabled = element.scrollWidth <= element.clientWidth;
  }
}
